import RequestStatus from "../model/RequestStatus";
import {GetReportResponse,} from "src/model/ProgramFees";
import {
    BULK_PRODUCTS_QUERY_FAILED,
    BULK_PRODUCTS_QUERY_NOT_LOADED,
    BULK_PRODUCTS_QUERY_START,
    BULK_PRODUCTS_QUERY_SUCCESS,
    GetBulkProductsQueryComplete
} from "src/actions/BulkReportQueryAction";

const initialState: GetReportResponse = {
    requestStatus: RequestStatus.NOT_LOADED,
    report: null,
};

export default (
    state: GetReportResponse = initialState,
    action: GetBulkProductsQueryComplete
): GetReportResponse => {
    switch (action.type) {
        case BULK_PRODUCTS_QUERY_START:
            return {
                requestStatus: RequestStatus.LOADING,
                report: null,
            };
        case BULK_PRODUCTS_QUERY_SUCCESS:
            return {
                requestStatus: RequestStatus.SUCCESS,
                report: action.report,
            };
        case BULK_PRODUCTS_QUERY_FAILED:
            return {
                requestStatus: RequestStatus.ERROR,
                report: null,
            };
        case BULK_PRODUCTS_QUERY_NOT_LOADED:
            return {
                requestStatus: RequestStatus.NOT_LOADED,
                report: null
            }
        default:
            return state;
    }
};
